import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { IconButton } from 'modules/common';

import * as c from './constants';

const CustomHeader = ({ props }) => {
  const {
    monthDate,
    customHeaderCount,
    decreaseMonth,
    increaseMonth,
    monthsShown,
  } = props;
  const isFrom = customHeaderCount === 1;

  return (
    <div className="relative pb-3 flex justify-center">
      <IconButton
        className={cn('absolute', {
          'left-1.5': !isFrom,
          'right-1.5 rotate-180': isFrom,
        })}
        onClick={isFrom ? increaseMonth : decreaseMonth}
        icon={($props) => <c.ArrowIcon {...$props} />}
        size="sm"
      />

      <div className="font-bold text-base mt-1">
        {dayjs(monthDate).format('MMMM YYYY')}
      </div>

      {monthsShown === 1 && (
        <IconButton
          className="absolute rotate-180 right-1.5"
          icon={($props) => <c.ArrowIcon {...$props} />}
          size="sm"
          onClick={isFrom ? decreaseMonth : increaseMonth}
        />
      )}
    </div>
  );
};

CustomHeader.defaultProps = {
  monthDate: new Date(),
  customHeaderCount: 0,
  monthsShown: 1,
  decreaseMonth: () => {},
  increaseMonth: () => {},
};

CustomHeader.propTypes = {
  monthDate: PropTypes.instanceOf(Date),
  props: PropTypes.instanceOf(Object).isRequired,
  customHeaderCount: PropTypes.number,
  monthsShown: PropTypes.number,
  decreaseMonth: PropTypes.func,
  increaseMonth: PropTypes.func,
};

export default CustomHeader;
